import React from "react";

function Credentials() {
  // const adjusters = [
  //   { name: "Mr. Lee (ABC)", title: "Lead Average Adjuster" },
  //   { name: "Ms. Chen (ABC)", title: "Senior Cargo Surveyor" },
  //   { name: "Dr. Al-Farsi", title: "Maritime Law Consultant" },
  //   { name: "Capt. Menon", title: "H&M Specialist / Auditor" },
  // ];

  const affiliations = [
    "Certified Average Adjusters",
    "ACRA regulatory compliance",
    "PDPA/GDPR Data Security (Requirement 4.4)",
  ];

  return (
    // <section id="credentials" className="bg-light-gray" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
    //   <div className="max-w-7xl mx-auto px-6">
    //     <h2 style={{ fontSize: '1.875rem', fontWeight: '700', textAlign: 'center', marginBottom: '1rem' }}>
    //       Our Authority, Our Commitment
    //     </h2>
    //     <p style={{ fontSize: '1.125rem', color: '#475569', textAlign: 'center', maxWidth: '48rem', margin: 'auto', marginBottom: '3rem' }}>
    //       Samudra Adjusting combines technical marine expertise with
    //       Singaporean regulatory integrity to deliver impartial and precise
    //       claims solutions.
    //     </p>

    //     <div className="grid-cols-1-md-2" style={{ marginBottom: '4rem', alignItems: 'flex-start' }}>
    //       <div className="credentials-card-gold">
    //         <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem' }}>
    //           Our Foundation: Precision & Trust
    //         </h3>
    //         <p style={{ color: '#475569', marginBottom: '1rem' }}>
    //           Established in Singapore, a global maritime hub, our core
    //           mission is to provide <strong>accurate and defensible</strong> average
    //           adjusting and claims advisory services. We transform complex
    //           incidents into clear, actionable, and compliant financial
    //           outcomes for our clients.
    //         </p>
    //         <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1d4ed8' }}>
    //           We drive <strong>Operational Excellence</strong> and <strong>Continuous
    //           Improvement</strong> across all service domains.
    //         </p>
    //       </div>

    //       <div className="credentials-card-blue">
    //         <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem' }}>Our Expertise & Focus</h3>
    //         <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
    //           <span style={{ fontSize: '2.25rem', color: 'var(--brand-gold)' }}>🚢</span>
    //           <p style={{ color: '#475569', fontWeight: '500' }}>
    //             Specialists in Hull & Machinery, Cargo Losses, Collision
    //             Liability, and the intricacies of <strong>General Average</strong>
    //             calculation and security management.
    //           </p>
    //         </div>
    //         <p style={{ fontSize: '0.875rem', color: '#475569', fontStyle: 'italic' }}>
    //           Our adjusters possess deep technical knowledge—from naval
    //           architecture to international maritime law (IMO, SOLAS, ISM
    //           Code).
    //         </p>
    //       </div>
    //     </div>

    //     <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
    //       <h3 style={{ fontSize: '1.875rem', fontWeight: '700', marginBottom: '1rem' }}>Meet Our Expert Adjusters</h3>
    //       <p style={{ color: '#475569', maxWidth: '56rem', margin: 'auto', marginBottom: '2rem' }}>
    //         Our team comprises experienced <strong>Claims Adjusters, Marine
    //         Insurance Consultants, and Master Mariners</strong> who are ready for
    //         rapid deployment.
    //       </p>

    //       <div className="grid-cols-2-md-4">
    //         {adjusters.map((person, index) => (
    //           <div className="adjuster-card" key={index}>
    //             <h4 style={{ fontWeight: '700', marginTop: '0.5rem' }}>{person.name}</h4>
    //             <p style={{ fontSize: '0.75rem', color: '#64748b' }}>{person.title}</p>
    //           </div>
    //         ))}
    //       </div>
    //     </div>

    //     <div style={{ textAlign: 'center', paddingTop: '2rem', borderTop: '1px solid #d1d5db' }}>
    //       <h3 style={{ fontSize: '1.875rem', fontWeight: '700', marginBottom: '1.5rem' }}>
    //         Affiliations & Regulatory Compliance
    //       </h3>
    //       <p style={{ fontSize: '1.125rem', color: '#475569', maxWidth: '48rem', margin: 'auto', marginBottom: '2rem' }}>
    //         We adhere strictly to international standards and Singapore's
    //         regulatory framework to provide you with assurance.
    //       </p>

    //       <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '2rem' }}>
    //         {affiliations.map((text, index) => (
    //           <div className="affiliation-tag" key={index}>{text}</div>
    //         ))}
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <>
      <section
        id="credentials"
        className="bg-light-gray"
        style={{ paddingTop: "4rem", paddingBottom: "4rem" , marginLeft: '3rem', marginRight: '3rem' }}
      >
        <div className="max-w-[80rem] mx-auto px-6">
          <h2
            style={{
              fontSize: "1.875rem",
              fontWeight: "700",
              textAlign: "center",
              marginBottom: "1rem",
            }}
          >
            Our Team
          </h2>
          <p
            style={{
              fontSize: "1.125rem",
              color: "#475569",
              textAlign: "center",
              maxWidth: "70rem",
              margin: "auto",
              marginBottom: "3rem",
            }}
          >
            At Samudra Adjusting & Marine Insurance Solutions, our strength lies
            in the experience, integrity, and technical depth of the
            professionals who represent us. We are a specialist practice built
            on rigorous standards, clear communication, and a commitment to
            supporting clients with precision and fairness.
          </p>

          <div
            className="grid-cols-1-md-2"
            style={{ marginBottom: "4rem", alignItems: "flex-start" }}
          >
            <div className="credentials-card-gold">
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                }}
              >
                Founder & Principal Consultant:{" "}
                <span>
                  <b>Capt. Manoj Rappal Varrier</b>
                </span>
              </h3>
              <p style={{ color: "#475569", marginBottom: "6rem" }}>
                LLM in (Maritime Law) from London University • Fellow of
                Association of Average Adjusters (U.K.) • MICS • OCIMF‑Qualified
                SIRE Inspector
                <br />
                <br />
                With over two decades of maritime and marine insurance
                experience, Capt. Manoj leads Samudra with a blend of seagoing
                command expertise, legal insight, and specialist adjusting
                capability. His work spans complex marine casualties, general
                average, collision liability, loss of hire claims, and technical
                investigations. Known for his clarity, diplomacy, and meticulous
                approach, he represents the firm’s commitment to professionalism
                and trust.
              </p>
              {/* <p style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1d4ed8' }}>
              We drive <strong>Operational Excellence</strong> and <strong>Continuous
              Improvement</strong> across all service domains.
            </p> */}
            </div>

            <div className="credentials-card-blue">
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "600",
                  marginBottom: "1rem",
                }}
              >
                Leena Mody
              </h3>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  marginBottom: "2rem",
                }}
              >
                {/* <span style={{ fontSize: '2.25rem', color: 'var(--brand-gold)' }}>🚢</span> */}
                <p style={{ color: "#475569", fontWeight: "500" }}>
                  Leena Mody (born 1963) qualified as a Fellow of the Insurance
                  Institute of India in 1990 and as a Fellow Member of the
                  Association of Average Adjusters, UK in 2002.  She is the
                  first lady in Asia and third in the world to qualify as an
                  Average Adjuster. Currently, she is the only independently
                  practicing lady Average Adjuster.
                  <br />
                  <br />
                  Leena has been practicing as an Average Adjuster with
                  International Insurance Brokers since 1993, and has over 27
                  years of experience in the marine insurance field. In 2012,
                  she established her own adjusting firm, M/s. Leena Mody &
                  Associates (LMA) in Mumbai, India
                  <br />
                  <br />
                  Leena is presently on the Examination as well as Advisory &
                  Dispute Resolution Panel of the Association of Average
                  Adjusters, UK and Member of the Association Mondiale de
                  Dispacheurs (AMD) / International Association of Average
                  Adjusters.
                </p>
              </div>
              {/* <p
              style={{
                fontSize: "0.875rem",
                color: "#475569",
                fontStyle: "italic",
              }}
            >
              Our adjusters possess deep technical knowledge—from naval
              architecture to international maritime law (IMO, SOLAS, ISM Code).
            </p> */}
            </div>
          </div>

          <div className="max-w-7xl mx-auto px-6">
            <h2
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "1rem",
                marginTop: "2rem",
              }}
            >
              Our Network of Specialists
            </h2>
            <p
              style={{
                fontSize: "1.125rem",
                color: "#475569",
                textAlign: "center",
                // maxWidth: "48rem",
                margin: "auto",
                marginBottom: "1rem",
              }}
            >
              Samudra has partnered with Leena Mody & Associates in Mumbai as
              part of regional collaboration in the field of average adjusting.
              <br />
              <br />
              Samudra collaborates with a trusted network of surveyors, legal
              experts, technical consultants, and industry specialists across
              key maritime hubs. This flexible model allows us to assemble the
              right expertise for each assignment while maintaining the personal
              accountability and responsiveness of a boutique firm.
            </p>
          </div>

          {/* Our Ethos Section - styled to match site */}
          {/* <div
            className="max-w-7xl mx-auto px-6">
            <h2
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
                Our Ethos
              </h2>
              <ul
                style={{
                  listStyle: "disc",
                  paddingLeft: "2rem",
                  color: "#334155",
                  fontSize: "1.1rem",
                  lineHeight: "1.7",
                }}
              >
                <li>
                  Integrity in every engagement — We act with independence,
                  fairness, and respect for all stakeholders.
                </li>
                <li>
                  Clarity in communication — Our reports, advice, and
                  correspondence reflect precision and transparency.
                </li>
                <li>
                  Responsiveness and reliability — Clients rely on us for timely
                  support, especially in high‑pressure situations.
                </li>
                <li>
                  Technical depth — Our work is grounded in maritime law,
                  operational experience, and industry best practices.
                </li>
                <li>
                  Confidentiality and data integrity — Sensitive information is
                  handled with discretion and secure processes.
                </li>
                <li>
                  Timeliness and responsiveness — We recognize the operational
                  and financial impact of delays and act accordingly.
                </li>
              </ul>
          </div> */}
          <div
            className="max-w-7xl mx-auto px-6"
            style={{ paddingTop: "4rem", paddingBottom: "4rem" }}
          >
            <h2
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "2.5rem",
              }}
            >
              Our Ethos
            </h2>
            <div className="grid-cols-1-md-2">
              <article
                style={{
                  padding: "1.25rem",
                  border: "1px solid #e5e7eb",
                  borderRadius: "0.5rem",
                  transition: "all 0.3s",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                  }}
                >
                  Integrity in every engagement :
                </h3>
                <p style={{ color: "#475569" }}>
                  We act with independence, fairness, and respect for all
                  stakeholders.
                </p>
              </article>
              <article
                style={{
                  padding: "1.25rem",
                  border: "1px solid #e5e7eb",
                  borderRadius: "0.5rem",
                  transition: "all 0.3s",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                  }}
                >
                  Clarity in communication :
                </h3>
                <p style={{ color: "#475569" }}>
                  Our reports, advice, and correspondence reflect precision and
                  transparency.
                </p>
              </article>
              <article
                style={{
                  padding: "1.25rem",
                  border: "1px solid #e5e7eb",
                  borderRadius: "0.5rem",
                  transition: "all 0.3s",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                  }}
                >
                  Responsiveness and reliability :
                </h3>
                <p style={{ color: "#475569" }}>
                  Clients rely on us for timely support, especially in
                  high‑pressure situations.
                </p>
              </article>
              <article
                style={{
                  padding: "1.25rem",
                  border: "1px solid #e5e7eb",
                  borderRadius: "0.5rem",
                  transition: "all 0.3s",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                  }}
                >
                  Technical depth :
                </h3>
                <p style={{ color: "#475569" }}>
                  Our work is grounded in maritime law, operational experience,
                  and industry best practices.
                </p>
              </article>
              <article
                style={{
                  padding: "1.25rem",
                  border: "1px solid #e5e7eb",
                  borderRadius: "0.5rem",
                  transition: "all 0.3s",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                  }}
                >
                  Confidentiality and data integrity :
                </h3>
                <p style={{ color: "#475569" }}>
                  Sensitive information is handled with discretion and secure
                  processes.
                </p>
              </article>
              <article
                style={{
                  padding: "1.25rem",
                  border: "1px solid #e5e7eb",
                  borderRadius: "0.5rem",
                  transition: "all 0.3s",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "0.5rem",
                  }}
                >
                  Timeliness and responsiveness :
                </h3>
                <p style={{ color: "#475569" }}>
                  We recognize the operational and financial impact of delays
                  and act accordingly.
                </p>
              </article>
            </div>
          </div>

          {/* <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <h3
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                marginBottom: "1rem",
              }}
            >
              Meet Our Expert Adjusters
            </h3>
            <p
              style={{
                color: "#475569",
                maxWidth: "56rem",
                margin: "auto",
                marginBottom: "2rem",
              }}
            >
              Our team comprises experienced{" "}
              <strong>
                Claims Adjusters, Marine Insurance Consultants, and Master
                Mariners
              </strong>{" "}
              who are ready for rapid deployment.
            </p>

            <div className="grid-cols-2-md-4">
              {adjusters.map((person, index) => (
                <div className="adjuster-card" key={index}>
                  <h4 style={{ fontWeight: "700", marginTop: "0.5rem" }}>
                    {person.name}
                  </h4>
                  <p style={{ fontSize: "0.75rem", color: "#64748b" }}>
                    {person.title}
                  </p>
                </div>
              ))}
            </div>
          </div> */}

          <div
            style={{
              textAlign: "center",
              paddingTop: "2rem",
              borderTop: "1px solid #d1d5db",
            }}
          >
            <h3
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                marginBottom: "1.5rem",
              }}
            >
              Affiliations & Regulatory Compliance
            </h3>
            <p
              style={{
                fontSize: "1.125rem",
                color: "#475569",
                maxWidth: "48rem",
                margin: "auto",
                marginBottom: "2rem",
              }}
            >
              We adhere strictly to international standards and Singapore's
              regulatory framework to provide you with assurance.
            </p>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "2rem",
              }}
            >
              {affiliations.map((text, index) => (
                <div className="affiliation-tag" key={index}>
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Credentials;
